import React from "react";
import { Page, PageHeader } from "components/ui/Page";
import { LargeSpacer } from "components/ui/VerticalSpacers";

import { BillingSummaryCard } from "components/cards/BillingSummaryCard";
import FinancialResourcesCard from "components/cards/FinancialResourcesCard";
import { TuitionStabilityCard } from "components/cards/TuitionStabilityCard";
import { FinancialAidSummaryCard } from "components/cards/FinancialAidSummaryCard";

import {
  EvenThirdsLayout,
  PageColumn,
  ColumnAtBreakpoint,
  ColumnUnlessBreakpoint,
} from "components/ui/PageColumns";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+My+Finances+Page
export default function FinancesPage() {
  return (
    <Page>
      <PageHeader>My Finances</PageHeader>
      <LargeSpacer />
      <EvenThirdsLayout>
        <PageColumn>
          <BillingSummaryCard />
          <TuitionStabilityCard />
        </PageColumn>
        <ColumnAtBreakpoint breakpointName="medium">
          <ColumnUnlessBreakpoint breakpointName="medium">
            <FinancialAidSummaryCard />
          </ColumnUnlessBreakpoint>
          <ColumnUnlessBreakpoint breakpointName="medium">
            <FinancialResourcesCard />
          </ColumnUnlessBreakpoint>
        </ColumnAtBreakpoint>
      </EvenThirdsLayout>
    </Page>
  );
}
FinancesPage.displayName = "FinancesPage";
